<template>
    <div class="pagination-container">
        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="currentPage"
            :page-sizes="pageSizes" :page-size="size" :layout="layout" :total="total" background small>
        </el-pagination>
    </div>
</template>

<script>
import _ from "lodash"
export default {
     name: "Pagination",
    components: {},
    computed: {
        pageSizes() {
            let temp = [10, 30, 50, 100, 200, 500]
            // let res= temp.filter(ik=>ik>=this.size)
            if (!temp.includes(this.tempSize)) {
                temp = [this.tempSize, ...temp]
            }
            temp = _.sortBy(temp)
            return temp
        }
    },
    props: {
        layout: {
            type: String,
            default: "total, sizes, prev, pager, next, jumper",
        },
        total: {
            type: Number,
            default: 0,
        },
        size: {
            type: Number,
            default: 10,
        },
        page: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            currentPage: 1,
            currentsize: 10,
            tempSize: 10
        };
    },
    mounted() {
        this.currentsize = this.size;
        this.tempSize = this.size;
        this.currentPage = this.page;
    },
    watch: {
        size() {
            this.currentsize = this.size;
        },
        page() {
            this.currentPage = this.page;
        },
    },
    methods: {
        sizeChange(val) {
            this.currentsize = val;
            // size变化时，默认定位到第一页
            this.currentPage = 1;
            this.$emit(
                'handlePageSizeChange',
                this.currentPage,
                this.currentsize
            );
        },
        pageChange(val) {
            this.currentPage = val;
            this.$emit(
                'handlePageSizeChange',
                this.currentPage,
                this.currentsize
            );
        },
    },
};
</script>
<style scoped>
.pagination-container {
    background: #fff;
    padding: 10px 0;

    text-align:center .el-input__inner {
        height: 25px;
    }

    .el-pagination {
        text-align: right
    }

    .el-pagination__sizes,
    .el-pagination__total {
        float: left
    }
}
</style>